import React, { useEffect, useRef, useState } from "react";
import styles from "./CustomRangeInput.module.scss";

const CustomRangeInput = (props) => {
    const [inputMin, setInputMin] = useState();
    const [inputMax, setInputMax] = useState();

    const maxInputRef = useRef();
    const minInputRef = useRef();

    const handleChangeMin = (event) => {
        setInputMin((prevState) => {
            return minInputRef.current.value;
        });
    };

    const handleChangeMax = (event) => {
        setInputMax((prevState) => {
            return maxInputRef.current.value;
        });
    };
    const handleBlurMin = (event) => {
        setInputMin((prevState) => {
            return minInputRef.current.value < props.minRange
                ? (minInputRef.current.value = props.minRange)
                : minInputRef.current.value > props.maxRange
                  ? (minInputRef.current.value = props.minRange)
                  : minInputRef.current.value;
        });
    };
    const handleBlurMax = (event) => {
        setInputMax((prevState) => {
            return maxInputRef.current.value > props.maxRange
                ? (maxInputRef.current.value = props.maxRange)
                : maxInputRef.current.value < props.minRange
                  ? (maxInputRef.current.value = props.maxRange)
                  : maxInputRef.current.value;
        });
    };

    const onRangeSubmit = () => {
        props.refineRange([Number(inputMin), Number(inputMax)]);
    };

    const rangeInputChecks =
        inputMin &&
        inputMax &&
        inputMin >= props.minRange &&
        inputMin <= props.maxRange &&
        inputMax >= props.minRange &&
        inputMax <= props.maxRange;

    // set input defaults if state is available
    useEffect(() => {
        setInputMax((prevState) => {
            return maxInputRef.current.value !== Infinity
                ? (maxInputRef.current.value = props.maxVal)
                : (maxInputRef.current.value = props.maxRange);
        });
        setInputMin((prevState) => {
            return minInputRef.current.value !== -Infinity
                ? (minInputRef.current.value = props.minVal)
                : (minInputRef.current.value = props.minRange);
        });
    }, [props.minVal, props.maxVal]);

    useEffect(() => {
        setInputMax((prevState) => {
            return prevState === Infinity
                ? (maxInputRef.current.value = props.maxRange)
                : (maxInputRef.current.value = props.maxVal);
        });
        setInputMin((prevState) => {
            return prevState === -Infinity
                ? (minInputRef.current.value = props.minRange)
                : (minInputRef.current.value = props.minVal);
        });
    }, []);

    return (
        <div className={styles["custom-range-input-container"]}>
            <label htmlFor="">
                <input
                    ref={minInputRef}
                    className={styles["custom-range-input"]}
                    id="custom-range-input-min"
                    type="number"
                    onChange={handleChangeMin}
                    onBlur={handleBlurMin}
                    placeholder={props.minRange}
                />
                <span className={styles["input-unit"]}>{props.unit}</span>
            </label>
            <span className={styles["input-spacer"]}>-</span>
            <label htmlFor="">
                <input
                    ref={maxInputRef}
                    className={styles["custom-range-input"]}
                    id="custom-range-input-max"
                    type="number"
                    onChange={handleChangeMax}
                    onBlur={handleBlurMax}
                    placeholder={props.maxRange}
                />
                <span className={styles["input-unit"]}>{props.unit}</span>
            </label>
            {rangeInputChecks ? (
                <button
                    className={styles["custom-range-input-btn"]}
                    onClick={onRangeSubmit}
                >
                    Anwenden
                </button>
            ) : (
                <button
                    disabled
                    className={styles["custom-range-input-btn"]}
                    onClick={onRangeSubmit}
                >
                    Anwenden
                </button>
            )}
        </div>
    );
};

export default CustomRangeInput;
